module.exports = __webpack_public_path__ + "img/de.52605345.png";